/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
// import { PropTypes } from 'prop-types';

const Newsletter = ({
  activeLanguage,
  handlerSetComponents,
  components,
  languages,
  id,
  reusableComponent,
  reusableComponentSlugname,
}) => {

  const initialState = {
    type: 'Newsletter',
    title:    { en: '' },
    text:     { en: '' },
    caption:  { en: '' },
    captionResponse: { en: '' },
    buttonText: { en: '' },
    scope: 'general',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  // const [showOptions, setShowOptions] = useState(false);

  const [title, setTitle] =   useState({ 'en': '' });
  const [text, setText] =     useState({ 'en': '' });
  const [caption, setCaption] = useState({ 'en': '' });
  const [captionResponse, setCaptionResponse] = useState({ 'en': '' });
  const [buttonText, setButtonText] = useState({ 'en': '' });
  const [scope, setScope] = useState('general');

  // useEffect(() => {
  //   if (slider) {
  //     setColorWhite(true);
  //     const comp = {
  //       ...state,
  //       color: 'white',
  //     };
  //     setState(comp);
  //   } else {
  //     setColorWhite(false);
  //     const comp = {
  //       ...state,
  //       color: 'black',
  //     };
  //     setState(comp);
  //   }
  // }, []);

  // const inputHandler = (e) => {
  //   const { value, name, lang } = e.target;

  //   const { component } = components[index];

  //   const comp = {
  //     ...component,
  //     [name]: {
  //       ...component[name],
  //       [lang.toLowerCase()]: value,
  //     },
  //   };

  //   setState(comp);

  //   const componentObj = {
  //     id,
  //     component: comp,
  //   };

  //   handlerSetComponents(componentObj, index);
  // };

  // const setChangeColor = () => {
  //   setColorWhite(!isColorWhite);

  //   if (index >= 0 && components.length) {
  //     const { component } = components[index];
  //     const borderColor = !isColorWhite ? 'white' : 'black';

  //     const comp = {
  //       ...component,
  //       color: borderColor,
  //     };
  //     setState(comp);

  //     const componentObj = {
  //       id,
  //       component: comp,
  //     };

  //     handlerSetComponents(componentObj, index);
  //   }
  // };

  // useEffect(() => {
  //   if (index >= 0 && components.length) {
  //     const { component } = components[index];
  //     const borderColor = isColorWhite ? 'white' : 'black';

  //     const comp = {
  //       ...component,
  //       color: borderColor,
  //     };
  //     setState(comp);

  //     const componentObj = {
  //       id,
  //       component: comp,
  //     };

  //     handlerSetComponents(componentObj, index);
  //   }
  // }, [isColorWhite]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          title: currentTitle,
          text: currentText,
          caption: currentCaption,
          captionResponse: currentCaptionResponse,
          buttonText: currentButtonText,
          scope: currentScope,
        } = component;

        setTitle(currentTitle);
        setText(currentText);
        setCaption(currentCaption);
        setCaptionResponse(currentCaptionResponse);
        setButtonText(currentButtonText);
        setScope(currentScope);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      title: { ...title },
      text: { ...text },
      caption: { ...caption },
      captionResponse: { ...captionResponse },
      buttonText: { ...buttonText },
      scope,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title,
    text,
    caption,
    captionResponse,
    buttonText,
    scope,
  ]);

  const titleChange = (e) => {
    switch (e.target.name){
      case 'title':
        title[activeLanguage] = e.target.value
        setTitle({ ...title });
      break;
      case 'text':
        text[activeLanguage] = e.target.value
        setText({ ...text });
        break;
      case 'caption':
        caption[activeLanguage] = e.target.value
        setCaption({ ...caption });
        break;
      case 'captionResponse':
        captionResponse[activeLanguage] = e.target.value
        setCaptionResponse({ ...captionResponse });
        break;
      case 'buttonText':
        buttonText[activeLanguage] = e.target.value
        setButtonText({ ...buttonText });
        break;
      default:
        console.log("Something wrong! titleChange -> titleChange", e.target.name)
        break;
    }
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex flex-wrap py-4">
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="title-text-change">
            Title
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            name="title"
            id="title-text-change"
            onChange={titleChange}
            value={title[activeLanguage]}
          />
        </div>
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Text
              </label>
          <textarea
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            name="text"
            onChange={titleChange}
            value={text[activeLanguage]}
          />
        </div>
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Caption
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            name="caption"
            onChange={titleChange}
            value={caption[activeLanguage]}
          />
        </div>
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Caption Response
              </label>
          <textarea
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            name="captionResponse"
            onChange={titleChange}
            value={captionResponse[activeLanguage]}
          />
        </div>
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Button Text
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            name="buttonText"
            onChange={titleChange}
            value={buttonText[activeLanguage]}
          />
        </div>
        <div className="w-full my-2">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Scope
          </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            onChange={(e) => setScope(e.target.value)}
            value={scope}
          />
        </div>
      </div>
    </div>
  );
};

// Newsletter.propTypes = {
//   activeLanguage: PropTypes.string.isRequired,
//   handlerSetComponents: PropTypes.func.isRequired,
//   components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
//   id: PropTypes.string.isRequired,
//   languages: PropTypes.arrayOf(PropTypes.string).isRequired,
//   reusableComponent: PropTypes.shape(),
//   slider: PropTypes.bool,
// };
// Newsletter.defaultProps = {
//   reusableComponent: null,
//   slider: false,
// };

export default Newsletter;
